import { render, staticRenderFns } from "./shop-channel-manual-lazada.vue?vue&type=template&id=0133eb18&scoped=true"
import script from "./shop-channel-manual-lazada.vue?vue&type=script&lang=js"
export * from "./shop-channel-manual-lazada.vue?vue&type=script&lang=js"
import style0 from "./shop-channel-manual-lazada.vue?vue&type=style&index=0&id=0133eb18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0133eb18",
  null
  
)

export default component.exports